import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

/**
 * Thin gold progress bar on route changes (NProgress-style, no dependency).
 * Sits at the very top of the viewport, animates 0 → 80% during navigation,
 * then snaps to 100 % and fades.
 */
export default function RouteProgress() {
  const location = useLocation();
  const [phase, setPhase] = useState("idle"); // idle | running | done

  useEffect(() => {
    setPhase("running");
    const t1 = setTimeout(() => setPhase("done"), 380);
    const t2 = setTimeout(() => setPhase("idle"), 780);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [location.pathname]);

  const width =
    phase === "running" ? "70%" :
    phase === "done" ? "100%" : "0%";
  const opacity = phase === "idle" ? 0 : 1;

  return (
    <div
      data-testid="route-progress"
      aria-hidden="true"
      style={{
        position: "fixed", top: 0, left: 0, right: 0, zIndex: 200,
        pointerEvents: "none", height: 3,
      }}
    >
      <div
        style={{
          height: "100%",
          width,
          opacity,
          background: "linear-gradient(90deg,#C5A059 0%,#E8CE89 50%,#C5A059 100%)",
          boxShadow: "0 0 10px rgba(197,160,89,0.65)",
          transition: phase === "done"
            ? "width 180ms ease-out, opacity 300ms ease-out 250ms"
            : "width 380ms cubic-bezier(.2,.8,.2,1), opacity 120ms",
        }}
      />
    </div>
  );
}
